import React, { Component } from 'react'
import { connect } from 'react-redux'
import { HeaderTop, StartSection } from '../../components'

class Programs extends Component {
  render() {
    return (
      <div className="programs">
        
        <HeaderTop />

        <div className="content">
          
            <StartSection />
              
        </div>

      </div>
    )
  }
}

export default connect()(Programs)



// WEBPACK FOOTER //
// ./src/screens/Programs/Programs.js